module.exports = __webpack_public_path__ + "static/img/GNSS05.e4e8cccc.png";